import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import groupBy from "lodash/groupBy";
import React, { FC, useContext } from "react";

import { css } from "styled-components";

export interface OrderTrackingInfoStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}

export const orderTrackingInfoStyles: OrderTrackingInfoStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = orderTrackingInfoStyles;

const OrderTrackingInfo: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties["trackingInfo"]) {
        return null;
    }

    const shippedLines = order.orderLines?.filter(ol => ol.status === "Shipped");
    const shipments = groupBy(shippedLines, line => line.properties["trackingInfo"]);
    const pendingLines = order.orderLines?.filter(ol => ol.status !== "Shipped");
    if (pendingLines && shipments && Object.entries(shipments).length + pendingLines.length !== 1) {
        return null;
    }
    const trackingInfo = Object.keys(shipments)[0];

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="trackingInfo">
                {translate("Tracking Link")}
            </Typography>
            <Typography {...styles.orderDate} aria-labelledby="trackingInfo">
                <Link target="_blank" rel="noopener noreferrer" href={trackingInfo}>
                    Click here to track your order!
                </Link>
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderTrackingInfo,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
